import { StorageSystem } from '../../forms'

export const saveStorageSettingsForRestore = (installationId: number | null, storageSystem: StorageSystem): void => {
  if (installationId === null) return

  sessionStorage.setItem(`deletedStorageSettings.${installationId}`, JSON.stringify(storageSystem))
}

export const getStorageSettingsToRestore = (installationId: number | null): StorageSystem | null => {
  if (installationId === null) return null

  const storageSettings = sessionStorage.getItem(`deletedStorageSettings.${installationId}`)

  if (!storageSettings) return null

  try {
    return JSON.parse(storageSettings) as StorageSystem
  } catch (error) {
    console.error('Error parsing storage settings from sessionStorage', error)
    return null
  }
}
